import Router from 'vue-router';
import Vue from 'vue';

import Home from '@/pages/home.page.vue';
import NotificationsPage from '@/pages/notifications/notifications.page.vue';
import PrintingPage from '@/pages/printing/print.page.vue';
import Callback from '@/pages/callback/callback.page.vue'

import {reportRoutes} from '@/modules/neodash/router';
import {dapRoutes} from '@/modules/dap/router';
import {directSalesRoutes} from '@/modules/direct-sales/router';
import bpaRoutes from '@/modules/business-plan/router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        ...reportRoutes,
        ...dapRoutes,
        ...directSalesRoutes,
        ...bpaRoutes,
        {
            component: PrintingPage,
            name: 'printing',
            path: '/printing'
        },
        {
            component: NotificationsPage,
            name: 'notifications-page',
            path: '/notifications'
        },
        {
            component: Home,
            name: 'home',
            path: '/',
            redirect: {name: 'reports-page'}
        },
        {
            component: Callback,
            name: 'callback',
            path: '/callback'
        }
    ]
});
